import { flow } from 'lodash'

export const trimSpace = (str) => str.trim()

export const cleanZeroWidthSpace = (str) => str?.replace(/[\u200B-\u200F\uFEFF\u00AD]/g, '')

export const stringProcessor = flow([cleanZeroWidthSpace, trimSpace])
